
<template>
  <!-- Manage Board Modal -->
  <BaseModal
    :no-exit="true"
    no-toolbar
    card-width="520px"
    no-padding
  >
    <template #default>
      <div
        ref="confettiAnchor"
      >
        <SpyderAnnualUpsell
          v-if="onboardStep === ONBOARD_STEPS.ANNUAL_UPSELL && currentPlan?.key"
          :product="currentPlan"
          :loading="loadingUpdate"
          @updateSubscription="handleSubscriptionChange"
          @skip="onboardStep = ONBOARD_STEPS.MERCH_REVIEW"
        />
        <MerchReviewOffer
          v-else-if="onboardStep === ONBOARD_STEPS.MERCH_REVIEW"
          @next="onboardStep = ONBOARD_STEPS.WELCOME"
        />
        <!-- Thank you / Welcome screen  -->
        <div
          v-else-if="onboardStep === ONBOARD_STEPS.WELCOME"
          class="flex flex-col"
        >
          <div class="team-banner rounded-t-xl overflow-hidden">
            <div class="flex flex-nowrap gap-4 items-center justify-center w-full h-ful py-14">
              <img
                v-for="(memberPic, index) in TEAM_PICTURES.LEFT"
                :key="`left-${index}`"
                :src="memberPic"
                class="w-11 h-11"
              >
              <div class="w-11 h-11 p-1.5 border border-neutral-alpha-200 rounded-xl">
                <ForeplayIcon class="w-8 h-8" />
              </div>
              <img
                v-for="(memberPic, index) in TEAM_PICTURES.RIGHT"
                :key="`right-${index}`"
                :src="memberPic"
                class="w-11 h-11"
              >
            </div>
          </div>
          <div class="flex-1 bg-white pt-9 pb-5 px-14 space-y-3 text-center">
            <BaseText
              type="heading"
              size="md"
            >
              Welcome to the club!
            </BaseText>
            <div class="space-y-4 text-text-normal">
              <BaseText size="sm">
                Thanks for subscribing to Foreplay! As you use your account we are here to support.
              </BaseText>
              <BaseText size="sm">
                Here are some helpful links along the way.
              </BaseText>
            </div>
          </div>
          <div class="p-5 grid grid-cols-12 gap-2">
            <button
              class="base-btn flex items-center gap-1.5 justify-center col-span-12"
              @click="openLink('https://foreplay.featurebase.app/help')"
            >
              <KnowledgeBaseUserIcon />
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Knowledge Base
              </BaseText>
            </button>
            <button
              class="base-btn flex items-center justify-center gap-1.5 col-span-6"
              @click="showIntercom"
            >
              <ChatSupportIcon />
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Customer Support
              </BaseText>
            </button>
            <button
              class="base-btn flex items-center justify-center gap-1.5 col-span-6"
              @click="openLink('https://www.youtube.com/@foreplay_co')"
            >
              <YoutubePlatformIcon />
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Youtube Channel
              </BaseText>
            </button>
            <button
              class="base-btn flex items-center justify-center col-span-6"
              @click="openLink('https://www.foreplay.co/fireside')"
            >
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Fireside Webinar Series
              </BaseText>
            </button>
            <button
              class="base-btn flex items-center justify-center col-span-6"
              @click="openLink('https://www.foreplay.co/university/classes')"
            >
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Foreplay University
              </BaseText>
            </button>
          </div>
          <div class="p-5">
            <button
              class="black-btn-primary rounded-md w-full py-2 px-2.5"
              @click="navToDiscovery"
            >
              <BaseText
                type="label"
                size="sm"
                class="text-white"
              >
                Complete
              </BaseText>
            </button>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import foreplayAPI from '@/api/foreplayServer'

// Sections
import SpyderAnnualUpsell from './postPurchaseModalStates/SpyderAnnualUpsell.vue'
import MerchReviewOffer from './postPurchaseModalStates/MerchReviewOffer.vue'
import ForeplayIcon from '../../globals/Icons/ForeplayIcon.vue'
import KnowledgeBaseUserIcon from '../../globals/Icons/SidebarIcons/user/KnowledgeBaseUserIcon.vue'
import ChatSupportIcon from '../../globals/Icons/ChatSupportIcon.vue'
import YoutubePlatformIcon from '../../globals/Icons/FilterIcons/Platforms/YouTubePlatformIcon.vue'
import products from '../../../utils/stripe/products'
export default {
  name: 'PurchaseOnboardModal',
  components: {
    SpyderAnnualUpsell,
    MerchReviewOffer,
    ForeplayIcon,
    ChatSupportIcon,
    YoutubePlatformIcon,
    KnowledgeBaseUserIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const TEAM_PICTURES = {
      LEFT: [
        require('../../../assets/images/team/eren-pfp.png'),
        require('../../../assets/images/team/sam-pfp.png'),
        require('../../../assets/images/team/omar-pfp.png'),
        require('../../../assets/images/team/zach-pfp.png')
      ],
      RIGHT: [
        require('../../../assets/images/team/jake-pfp.png'),
        require('../../../assets/images/team/nathan-pfp.png'),
        require('../../../assets/images/team/maham-pfp.png'),
        require('../../../assets/images/team/anas-pfp.png')
      ]
    }
    const ONBOARD_STEPS = {
      ANNUAL_UPSELL: 0,
      MERCH_REVIEW: 1,
      WELCOME: 2
    }

    return {
      ONBOARD_STEPS,
      TEAM_PICTURES,

      loadingUpdate: false,

      currentPlan: null,

      onboardStep: ONBOARD_STEPS.ANNUAL_UPSELL
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUserSubscription', 'getUser'])
  },
  watch: {
    onboardStep (newVal) {
      if (newVal === this.ONBOARD_STEPS.WELCOME) {
        this.$confetti.start({
          defaultType: 'rect'
        })

        setTimeout(() => {
          this.$confetti.stop()
        }, 1500)
      }
    }
  },
  async mounted () {
    this.currentPlan = {
      key: this.getUserSubscription?.internalProductId,
      interval: this.getUserSubscription?.interval
    }

    // Skip spyder upsell if not monthly
    if (this.currentPlan.interval !== 'month') {
      this.onboardStep = this.ONBOARD_STEPS.MERCH_REVIEW
    }

    if (!this.currentPlan?.key) {
      this.$router.push({ name: 'LibraryView' })
    }

    // TODO Redis @Sam: fix this shit
    try {
      // GTAG Tracking for successful purchase
      const intervalKey = this.currentPlan?.interval === 'month' ? 'monthly' : 'annual'
      const purchasedPlan = products.find((prod) => prod.key === this.currentPlan.key)
      const layerItems = this.getUserSubscription?.items.map((item) => {
        const itemProduct = item?.price?.product
        const baseQuantity = purchasedPlan?.baseQuantity
        const addOnQuantity = purchasedPlan?.addOns?.lens?.[intervalKey]?.quantity

        const additionalLenses = item.quantity - addOnQuantity
        // Calculate general price from client side products data
        const itemPrice = itemProduct?.metadata?.internal_product_id === this.currentPlan.key
          ? purchasedPlan?.price?.[intervalKey] + (item.quantity - baseQuantity) * 20
          : additionalLenses < 0 ? 0 : additionalLenses * 50
        return {
          item_name: itemProduct?.name,
          price: itemPrice,
          item_id: itemProduct?.id,
          quantity: item.quantity
        }
      })
      window.dataLayer.push({
        event: 'app_purchase',
        user_data: {
          email_address: this.getUser?.email
        },
        ecommerce: {
          transaction_id: this.getUserSubscription?.id,
          value: purchasedPlan?.price?.[intervalKey],
          currency: 'USD',
          items: layerItems
        }
      })
    } catch (e) {
      console.error('Error tracking purchase', e)
    }
  },
  methods: {
    ...mapActions('AuthModule', ['logoutUser']),
    showIntercom () {
      window.Intercom('show')
    },
    openLink (urlRedirect) {
      window.open(urlRedirect, '_blank')
    },
    navToDiscovery () {
      this.$router.push({ name: 'DiscoveryView' })
    },
    async handleSubscriptionChange (newSub) {
      const { priceId, _key, addOn } = newSub || {}
      this.loadingUpdate = true
      try {
        const updateRes = await foreplayAPI.Subscription.changeSubscription(priceId, addOn)
        this.onboardStep += 1
        this.$showAlert({ type: 'success', message: 'Your subscription plan has been successfully updated!' })
      } catch (e) {
        if (e.response && e.response.status === 400) {
          this.$showAlert({ type: 'error', message: 'An unexpected error occurred. You have not been charged.' })
        } else {
          console.error(e)
          this.$showAlert({ type: 'error', message: 'An unexpected error occurred. Please try again later.' })
        }
      } finally {
        this.loadingUpdate = false
      }
    }
  }
}
</script>

<style scoped>
.team-banner{
  background: linear-gradient(0deg, #060710, #060710),
linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08));
}

.base-btn {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}
</style>
